export enum RentalPropertyStatusEnum {
  Pending = 'Pending',
  Approved = 'Approved',
  Expired = 'Expired',
  Rejected = 'Rejected',
}

export const rentalPropertyStatusColorMap: Record<RentalPropertyStatusEnum, string> = {
  [RentalPropertyStatusEnum.Pending]: '#FFD889',
  [RentalPropertyStatusEnum.Approved]: '#C1FFEA',
  [RentalPropertyStatusEnum.Expired]: '#DCDCDC',
  [RentalPropertyStatusEnum.Rejected]: '#FFA39E',
};
